import { render, staticRenderFns } from "./GlobalWidgetsDialogs.vue?vue&type=template&id=57cd14d0&scoped=true"
import script from "./GlobalWidgetsDialogs.vue?vue&type=script&lang=js"
export * from "./GlobalWidgetsDialogs.vue?vue&type=script&lang=js"
import style0 from "./GlobalWidgetsDialogs.vue?vue&type=style&index=0&id=57cd14d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cd14d0",
  null
  
)

export default component.exports